<custom-table [config]="customTable" [rowExpansionTemplate]="tableRowexpansion">
</custom-table>
<ng-template #tableRowexpansion let-data>
	<app-admin-dependencia-usuarios [dependenciaId]="data.id"
                                  class="app-card w-11 mx-auto border-1 border-top-none border-noround-top"/>
</ng-template>
